import css from 'styled-jsx/css';

export default css`
  .faq-head {
    margin: 16px 0px 20px;
  }
  .faq-container {
    margin-bottom: 40px;
  }
  .faq-container :global(.accordion-container) {
    border: none;
    margin: 0px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .faq-container .col-xl-8 {
    border: solid thin #ccc5;
    background: var(--background-utils);
  }
  .faq-container .col-xl-8:not(:last-child) {
    border-bottom: none;
  }
  .faq-container :global(.accordion-text) {
    font-size: 16px;
    color: var(--foreground);
    font-weight: 500;
  }
  .faq-container :global(.accordion-icon) {
    right: 0px;
    color: var(--foreground);
  }
  .faq-container :global(.accordion-content > div) {
    padding: 20px 0px;
  }
  @media screen and (max-width: 768px) {
    .faq-container :global(.accordion-text) {
      margin: 0px;
    }
    .faq-container .col-xl-8 {
      border: solid thin #ccc5;
      margin: 0px;
    }
    .faq-container :global(.accordion-container) {
      border: none;
      margin: 0px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
